<template>
    <div class="flex flex-col text-default">
        <img class="mx-auto w-screen" alt="Vue logo" src="../../assets/Logo.svg">
        <a href="https://www.linkedin.com/in/klaassenconnor" target="_blank" rel="noopener noreferrer">
            <Icon class="mr-2" :icon="['fab', 'linkedin']"/>
            <u>Connor Klaassen</u>
        </a>
        <a href="mailto:cklaasse@purdue.edu">
            <Icon class="mr-2" :icon="['fas', 'envelope-square']"/>
            <u>cklaasse@purdue.edu</u>
        </a>
        <a href="https://gitlab.com/cklaassen" target="_blank" rel="noopener noreferrer">
            <Icon class="mr-2" :icon="['fab', 'gitlab']"/>
            <u>cklaassen</u>
        </a>
        <a href="https://github.com/cklaassen" target="_blank" rel="noopener noreferrer">
            <Icon class="mr-2" :icon="['fab', 'github']"/>
            <u>cklaassen</u>
        </a>
        <div class="content-center text-center text-lg cursor-default text-default font-text mx-2">
            <br>
            <br>
            <span>Hello!  I am Connor Klaassen, a computer science student at Purdue University, currently working on honing my skills as a developer.
                  Along with my studies, I am building Keryx, a workspace to facilitate complex, relationship based communications.
                <br>
                <br>
                Ever since I was first introduced to programming on Khan Academy’s wonderful scripting emulator, it has been impossible to drag me away from a computer.
                  Whether it’s attempting to automate my homework, building the next big startup, or anything in between, I love it all.
                  The lure of being able to turn an empty file into a functioning complex system has kept me hooked since the 5<sup>th</sup> grade.
            </span>
        </div>
    </div>
</template>
